var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "_eui-hjalpknapp",
      class: { "-osynlig": _vm.vpOsynlig },
      attrs: { id: _vm.idHjalpknapp, disabled: _vm.vpInaktiverad }
    },
    [
      _c(
        "eui-knapp",
        {
          staticStyle: {
            display: "inline-flex",
            width: "100%",
            height: "100%",
            padding: ".12em"
          },
          style: { color: _vm.vpColor },
          attrs: {
            id: _vm.idHjalpknappKnapp,
            disabled: _vm.vpInaktiverad,
            "vp-tooltip": _vm.vpTooltip,
            "vp-css-modifier-class": "-transparent"
          }
        },
        [
          _c("eui-modifierad-svg", {
            staticStyle: { "stroke-width": "1.4" },
            attrs: { "vp-ikon": "hjalpknapp" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "_eui-hjalpknapp-text mindre",
          staticStyle: { display: "none" },
          attrs: { id: _vm.idHjalpknappText }
        },
        [
          _vm._t("default", [_vm._v("\n\t\t\tHjälpknapp-text saknas :(\n\t\t")])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }